<span [attr.title]="disabled ? value?.toFixed(2).toLocaleString() : null">
	<kendo-numerictextbox #num [style]="style"
		[min]="min" [max]="max" [disabled]="disabled" [value]="value"
		[step]="100" [decimals]="decimals" [format]="format" [spinners]="!disabled"
		[maxlength]="5" [step]="step"
		(blur)="onValueChange()" (click)="onAfterValueChange()">
	</kendo-numerictextbox>
</span>

